import { persistReducer } from 'redux-persist';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { reducers } from '../reducers';
import rootSaga from '../sagas';
import axios from '../internal/axios';
var apiEndpoint;
var asyncLocalStorage;

var locale = function locale() {
  return 'en';
};

export var getApiEndpoint = function getApiEndpoint() {
  return apiEndpoint;
};
export var getAsyncLocalStorage = function getAsyncLocalStorage() {
  return asyncLocalStorage;
};
export var getLocale = function getLocale() {
  return locale();
};
export var createLearningStore = function createLearningStore(apiEndpointFrom, localeFrom, asyncLocalStorageFrom, persistConfig) {
  var store;
  var sageMiddleware = createSagaMiddleware();

  if (persistConfig) {
    var persistedReducer = persistReducer(persistConfig, reducers);
    store = createStore(persistedReducer, applyMiddleware(sageMiddleware));
  } else {
    store = createStore(reducers, applyMiddleware(sageMiddleware));
  }

  sageMiddleware.run(rootSaga);
  apiEndpoint = apiEndpointFrom;
  asyncLocalStorage = asyncLocalStorageFrom;
  locale = localeFrom;
  axios.defaults.baseURL = apiEndpoint;
  return store;
};